"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceHeaderMetadataCertification = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
/**
 * Renders the certification icon/popup alongside text showing the name of the certifier,
 * for use in place page headers.
 * @param props
 */
function PlaceHeaderMetadataCertification(props) {
    var _a, _b;
    var urls = React.useContext(data_catalog_shared_1.SiteUrlsContext);
    if (props.dataQualityCertifications.length > 0) {
        return (React.createElement(data_catalog_shared_1.CertificationStatusChipOrIcon, { kind: 'graph', urls: urls, iconOnly: false, subjectArea: props.subjectArea, anchoredAsset: props.anchoredAsset, anchoredCertifications: [{
                    __typename: 'DataQualityCertification',
                    vizportalId: props.vizportalId,
                    author: props.dataQualityCertifications[0].author,
                    authorDisplayName: (_b = (_a = props.dataQualityCertifications[0].author) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
                    message: props.dataQualityCertifications[0].message,
                    isActive: props.dataQualityCertifications[0].isActive,
                    updatedAt: new Date(props.dataQualityCertifications[0].updatedAt)
                }] }));
    }
    else {
        return null;
    }
}
exports.PlaceHeaderMetadataCertification = PlaceHeaderMetadataCertification;
//# sourceMappingURL=PlaceHeaderMetadataCertification.js.map